import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import Icon from 'components/Icon'
import { MenuMainContext } from 'contexts/MenuMain'
import { Text } from 'styles/components/typography'

import { timeline } from './animation'
import {
  TextWrapper,
  Num,
  NumWrapper,
  IconWrapper,
  BoxBaseStyled,
} from './styles'
import useScrollMagic from 'hooks/useScrollMagic'

const WCoveringDesktop = ({ data }) => {
  const { menuNode } = React.useContext(MenuMainContext)
  const { colors } = React.useContext(ThemeContext)
  const offset = React.useMemo(() => menuNode?.getBoundingClientRect().height, [
    menuNode,
  ])
  const trigger = React.useRef()
  const numRef = React.useRef()
  const iconRef = React.useRef()
  const textRef = React.useRef()

  const { ScrollMagic, isScrollMagicLoaded } = useScrollMagic({ inView: true })

  React.useEffect(() => {
    require('animation.gsap')
  }, [])

  React.useEffect(() => {
    if (isScrollMagicLoaded) {
      const controller = new ScrollMagic.Controller()
      const mainScene = new ScrollMagic.Scene({
        triggerHook: 0,
        triggerElement: trigger.current,
        offset: -offset,
        duration: 1600,
      })
        .setPin(trigger.current)
        .setTween(timeline({ iconRef, numRef, textRef }))

      controller.addScene(mainScene)

      return () => {
        mainScene.removePin(true)
        controller.destroy()
      }
    }
  }, [offset, isScrollMagicLoaded])

  return (
    <BoxBaseStyled
      ref={trigger}
      bg={colors.white}
      minHeight={`calc(100vh - ${offset}px)`}
      overflow="hidden"
      alignItems="center"
      justifyContent="center"
      display="flex"
      flexDirection="column"
    >
      <NumWrapper>
        <Num ref={numRef} dangerouslySetInnerHTML={{ __html: data.num }} />
        <IconWrapper ref={iconRef}>
          <Icon color={colors.black} id="close_large" strokeWidth="15" />
        </IconWrapper>
      </NumWrapper>

      <TextWrapper ref={textRef}>
        <Text dangerouslySetInnerHTML={{ __html: data.text }} />
      </TextWrapper>
    </BoxBaseStyled>
  )
}

WCoveringDesktop.propTypes = {
  data: PropTypes.object.isRequired,
}

export default WCoveringDesktop
